module.exports = __webpack_public_path__ + "static/media/GUM-BNB.1e6c5cdf.svg";